import { render, staticRenderFns } from "./AnyComponent.vue?vue&type=template&id=6c4d48ab&scoped=true"
import script from "./AnyComponent.vue?vue&type=script&lang=js"
export * from "./AnyComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4d48ab",
  null
  
)

export default component.exports